import { useState } from 'react';
import { httpClientCancelTokenStatic } from '@trader/services';
import { api } from '@trader/api';
import { CancelTokenSource } from 'axios';

let cancelTokenSource: CancelTokenSource | null = null;

export const useRequiredMargin = () => {
  const [requiredMargin, setRequiredMargin] = useState(0);
  const [isRequiredMarginError, setRequiredMarginError] = useState(false);
  const getRequiredMargin = async (symbol, side, quantity, price) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel('CANCEL_REQUEST');
    }

    cancelTokenSource = httpClientCancelTokenStatic.source();
    try {
      const response = await api.Trading.getRequiredMargin(
        {
          symbol,
          side,
          quantity,
          price,
        },
        {
          cancelToken: {
            cancelToken: cancelTokenSource.token,
          },
        }
      );
      response?.requiredOpenCosts &&
        setRequiredMargin(response?.requiredOpenCosts);
      setRequiredMarginError(false);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (error.message !== 'CANCEL_REQUEST') {
        setRequiredMarginError(true);
      }
    }
  };

  return {
    requiredMargin,
    getRequiredMargin,
    isRequiredMarginError,
  };
};
